export const CRITERION_TYPE = 'STICK'